const messages = {
    en: {
        role: {
            permissions: {
                BASE_SHOW: "View base settings",
                NOTIFICATION_CREATE: "Create Notification",
                NOTIFICATION_SHOW: "View Notification",
                NOTIFICATION_UPDATE: "Modify Notification"
            }
        }
    },
    es: {
        role: {
            permissions: {
                BASE_SHOW: "Ver ajustes base",
                NOTIFICATION_CREATE: "Crear Notificación",
                NOTIFICATION_SHOW: "Ver Notificación",
                NOTIFICATION_UPDATE: "Modificar Notificación"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                BASE_SHOW: "Ver configurações base",
                NOTIFICATION_CREATE: "Criar Notificação",
                NOTIFICATION_SHOW: "Ver Notificação",
                NOTIFICATION_UPDATE: "Modificar Notificação"
            }
        }
    }
}

export default messages
